module.exports = __webpack_public_path__ + "img/step1-c.078add90.png";